import { lang, CANTONESE } from './lang';
import { createI18n } from "svelte-simple-i18n";

export const { t, locale } = createI18n({
  messages: lang,
  locale: CANTONESE,
  fallbackLocale: CANTONESE,
});